import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { Card, CardHeader, CardContent } from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import Select from '../components/ui/Select';
import StatCard from '../components/ui/StatCard';
import { Users, UserPlus, TrendingUp } from 'lucide-react';

export default function TeamPage() {
  const [selectedLevel, setSelectedLevel] = useState('1');
  const { data: stats } = useQuery({ queryKey: ['teamStats'], queryFn: () => api.get('/mlm/stats').then(r => r.data) });
  const { data: levelMembers } = useQuery({ queryKey: ['levelMembers', selectedLevel], queryFn: () => api.get('/mlm/levels/' + selectedLevel).then(r => r.data) });

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="d-page-header">
        <h1 className="text-2xl font-bold text-white">My Team</h1>
        <p className="text-slate-400 mt-1">Your network at a glance.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard title="Team Size" value={stats?.totalTeamSize || 0} icon={Users} />
        <StatCard title="Direct Referrals" value={stats?.directReferrals || 0} icon={UserPlus} />
        <StatCard title="Active Members" value={stats?.activeTeam || 0} icon={TrendingUp} />
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <h2 className="text-base font-semibold text-white">Team Members</h2>
            <Select
              label="Level"
              options={Array.from({ length: 30 }, (_, i) => ({ value: String(i + 1), label: 'Level ' + (i + 1) }))}
              value={selectedLevel}
              onChange={(e) => setSelectedLevel(e.target.value)}
              className="w-auto"
            />
          </div>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="d-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Status</th>
                  <th>Joined</th>
                </tr>
              </thead>
              <tbody>
                {levelMembers?.length === 0 ? (
                  <tr><td colSpan={3} className="text-center py-8 text-slate-500">No members at this level</td></tr>
                ) : (
                  levelMembers?.map((m: any) => (
                    <tr key={m.id}>
                      <td>
                        <div className="flex items-center gap-2.5">
                          <div className="w-8 h-8 rounded-full bg-primary-600/20 flex items-center justify-center text-xs font-semibold text-primary-400">
                            {m.user?.username?.[0]?.toUpperCase()}
                          </div>
                          <div>
                            <p className="text-sm font-medium text-white">{m.user?.profile?.fullName || m.user?.username}</p>
                            <p className="text-xs text-slate-500">@{m.user?.username}</p>
                          </div>
                        </div>
                      </td>
                      <td><Badge status={m.user?.isActive ? 'ACTIVE' : 'INACTIVE'} /></td>
                      <td className="text-sm text-slate-400">{new Date(m.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
